import { useEffect, useState } from 'react'

import { Box } from '@factorialco/deprecated-design-system'
import { F0Button } from '@factorialco/f0-react'
import { motion } from 'framer-motion'

import i18n from 'modules/core/lib/i18n'

import './index.styles.css'
type Props = {
  collapsed?: boolean
  collapsedHeight?: number
  children: React.ReactNode
  onChange?: (collapsed: boolean) => void
}

export const CollapsibleTeaserBlock = ({
  collapsed,
  collapsedHeight = 100,
  children,
  onChange,
}: Props) => {
  const [localCollapsed, setLocalCollapsed] = useState(collapsed ?? true)

  useEffect(() => {
    if (onChange) {
      onChange(localCollapsed)
    }
  }, [localCollapsed, onChange])

  return (
    <Box className="flex flex-col">
      <motion.div
        className="overflow-hidden relative"
        style={{
          height: localCollapsed ? collapsedHeight : 'auto',
        }}
        animate={{ height: localCollapsed ? collapsedHeight : 'auto' }}
        transition={{ duration: 0.3, ease: 'easeInOut' }}
      >
        {children}
        {localCollapsed && <Box className={'CollapsibleTeaserBlock_fadeOverlay'} />}
      </motion.div>

      <Box alignItems="flexEnd">
        <F0Button
          onClick={() => setLocalCollapsed(!localCollapsed)}
          variant="ghost"
          label={
            localCollapsed
              ? i18n.t('ai_reports.reports.expand')
              : i18n.t('ai_reports.reports.collapse')
          }
        />
      </Box>
    </Box>
  )
}
